import React from 'react'
import { Outlet } from 'react-router-dom'
import PartnerNavComponent from './PartnerNavComponent'

const PartnerAuth = () => {
  const partnerPageDashboardMenu = ["Home", "Pool"];
  return (
    <>
      <PartnerNavComponent dashboadMenus={partnerPageDashboardMenu} />
      <Outlet />
    </>
  )
}

export default PartnerAuth